import { CreateViewRequest, CpsGridView, CpsView, UpdateViewRequest } from '@cs-cms/types';
import { ExecuteEndpoint } from '../base/BaseApiService';

export class ViewsService {
  public async deleteView(viewId: number): Promise<boolean> {
    return ExecuteEndpoint(`views/${viewId}`, 'DELETE');
  }

  public async createView(createViewRequest: CreateViewRequest): Promise<number> {
    return ExecuteEndpoint(`views`, 'POST', { json: createViewRequest });
  }

  public async getView(viewId: number, locale?: string): Promise<CpsView> {
    const searchParams = new URLSearchParams();
    if (locale) {
      searchParams.append('locale', locale);
    }

    const queryParams = searchParams.size > 0 ? `?${searchParams.toString()}` : '';
    return ExecuteEndpoint(`views/${viewId}${queryParams}`, 'GET');
  }

  public async updateView(updateViewRequest: UpdateViewRequest): Promise<boolean> {
    return ExecuteEndpoint(`views/${updateViewRequest.viewId}`, 'PATCH', {
      json: {
        name: updateViewRequest.name,
        isDefault: updateViewRequest.isDefault,
        fields: updateViewRequest.fields,
        globalFilters: updateViewRequest.globalFilters
      }
    });
  }

  public async getViews(indexId: number): Promise<CpsGridView[]> {
    const queryParams = new URLSearchParams();
    queryParams.append('indexId', indexId.toString());

    return ExecuteEndpoint(`views?${queryParams}`, 'GET');
  }

  public async getWritePermission(indexId: number): Promise<boolean> {
    return ExecuteEndpoint(`views/indexes/${indexId}/write-permission`, 'GET');
  }

  public async getCreatePermission(indexId: number): Promise<boolean> {
    return ExecuteEndpoint(`views/indexes/${indexId}/create-permission`, 'GET');
  }
}
